import { FEED_AUTH_KEY, FEED_FARM_DAY_KEY, FEED_ZOOM_LEVEL } from '@/constants';

export function logoutMiddleware() {
  localStorage.removeItem(FEED_AUTH_KEY);
  localStorage.removeItem(FEED_FARM_DAY_KEY);
  localStorage.removeItem(FEED_ZOOM_LEVEL);
  localStorage.removeItem('theme');
  localStorage.removeItem('currentSession');
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('FEED:open-menu');
  localStorage.removeItem('FEED:current-session');
  localStorage.removeItem('FEED:current-navigation');
  localStorage.removeItem('bS');
  localStorage.removeItem('cAS1');
  localStorage.removeItem('cAS2');
  localStorage.removeItem('i18nextLng');
  //Essa linha apaga o 'lembrar de mim' e 'as config padrão do binário'
  // localStorage.clear();
}
